import { Box, Card, CardContent, Typography, useTheme } from '@mui/material'
import { ReactNode } from 'react'
import SkeletonView from './SkeletonView'
import zIndexes from '../theme/zIndexes'

interface Props {
  title: string
  rightContent?: ReactNode
  toolbarContent?: ReactNode
  loading?: boolean
}

const ModalDrawerToolbar = (props: Props) => {
  const { title, rightContent, toolbarContent } = props
  const theme = useTheme()

  return <Box sx={{ position: 'sticky', top: 0, zIndex: zIndexes.contentHigh }}>
    <Card square elevation={4}>
      <CardContent sx={{
        pb: `${theme.spacing(3)} !important`,
        pt: theme.spacing(3),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        gap: 3,
      }}>
        {props.loading
          ? <Box sx={{ px: 1, width: '100%' }}>
            <SkeletonView layout={[['L']]} />
          </Box>
          : <>
            <Box sx={{ px: 1, overflow: 'hidden' }}>
              <Typography
                sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                variant='h5'
              >
                {title}
              </Typography>
              {toolbarContent}
            </Box>

            {rightContent}
          </>
        }
      </CardContent>
    </Card>
  </Box>
}

export default ModalDrawerToolbar